<template>
  <v-form @submit.prevent="download()">
    <sds-card title="Parâmetros da Consulta">
      <v-row dense>
        <v-col cols="12" class="d-flex">
          <sds-input-control label="Data de Validade:">
            <span class="d-flex">
              <SdsDateField
                v-model="state.dtValidadeInicio"
                :max="state.dtValidadeFim"
                :name="$t('label.DATA_INICIAL')"
                :label-less-than-minimum="
                  $t('label.ERROR_DATA_FINAL_MENOR_QUE_INICIAL')
                "
                :label-greater-than-maximum="
                  $t('label.ERROR_DATA_INICIAL_MAIOR_QUE_FINAL')
                "
              />
              <span class="mx-2 d-flex align-center">
                {{ $t('label.ATE') }}
              </span>
              <SdsDateField
                :value="state.dtValidadeFim"
                disabled
                :name="$t('label.DATA_FINAL')"
              />
            </span>
          </sds-input-control>
          <SdsTextField
            label="Dias Próx. da Validade:"
            v-model="state.nuDiasProximoValidade"
            class="d-inline-block ml-2"
            style="min-width: 190px"
          />
        </v-col>
        <v-col cols="12" class="mb-6">
          <v-radio-group
            :mandatory="true"
            v-model="state.tpImpressao"
            row
            hide-details
          >
            <v-radio label="XLSX" value="XLSX" />
            <v-radio label="PDF" value="PDF" />
          </v-radio-group>
        </v-col>
      </v-row>
      <v-divider />
      <template #actions-right>
        <v-btn text color="primary" @click="reloadPage()"> Limpar </v-btn>
        <v-btn depressed color="primary" class="ml-2" type="submit">
          Visualizar
        </v-btn>
      </template>
    </sds-card>
  </v-form>
</template>

<script lang="ts" setup>
import SdsSnackbarQueue from '@ungp/sds-snackbar-queue';
import ParecerReferencialService from '../service/ParecerReferencialService';
import SdsDateField from '@/components/SdsDateField.vue';
import SdsTextField from '@/components/SdsTextField.vue';
import { getFilenameFromHeaders, reloadPage } from '@/utils';
import { reactive } from 'vue';
import { FiltroRelatorioPareceresVencidos } from '../types';
import FileDownload from 'js-file-download';
import { getAxiosError } from '@/plugins/axios';
import moment from 'moment';

const getInitialFilter = (): FiltroRelatorioPareceresVencidos => ({
  dtValidadeInicio: null,
  dtValidadeFim: moment().format('DD/MM/yyyy'),
  nuDiasProximoValidade: 30,
  tpImpressao: 'PDF',
});

const state = reactive<FiltroRelatorioPareceresVencidos>(getInitialFilter());

const download = async () => {
  try {
    const { data, headers } =
      await ParecerReferencialService.downloadRelatorioPareceresVencidos(state);

    FileDownload(data, getFilenameFromHeaders(headers));
  } catch (error) {
    SdsSnackbarQueue.error(
      getAxiosError(error, 'Não foi possível realizar o download')
    );
  }
};
</script>
<style lang="scss" scoped>
#button-container {
  margin-left: 800px;
}
</style>
